import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";


import { ToastrService } from "../../../../../../services/toastr.service";


import DiagnosisTableRow from "./DiagnosisTableRow.vue";
import TableEmpty from "../../../../../../resources-vue/vue-custom-elements/TableEmpty/TableEmpty.vue";

export default defineComponent({
    components: {
         TableEmpty,
         DiagnosisTableRow
    },
    props: {
        diagnosis: {
            type: Array<any>,
            default: []
        },
        id: {
            type: String
        },
        snapshotView: {
            type: Boolean,
            default: false
        },
        updateDiagnosis: {
            type: Function
        },
        application: {
            type: Number
        },
        historyView:{
            type:Boolean,
            default:false
        },
        hideResolved:{
            type:Boolean,
            default:false
        },
        preventFuture:{
            type:Boolean,
            default:false
        },
        isViewDetailsRequested:{
            type:Boolean,
            default:false
        },
        limit:{
            type:Number,
            default:-1
        }

    },
    data(vm) {
        return {
            newDiagnosis: [],
            _toastrService: null,
            isNewTerminal: false,
            columns: 5,
            isAddRequested: true
        };
    },
    created() {
        this._toastrService = Container.instance.get(ToastrService);
    },
    mounted() {
        if (this.diagnosis.length) {
            let temp = [
                ...this.diagnosis.filter((d: any) => !d.ResolvedDate).sort((a: any, b: any) => a.Order - b.Order),
                ...this.diagnosis.filter((d: any) => d.ResolvedDate)
            ];
            this.updateDiagnosis(temp);
        }
        if (this.diagnosis && this.diagnosis[0] && this.diagnosis[0].Order != 1) {
            let temp = Array(this.diagnosis[0].Order - 1)
                .fill(null)
                .concat(this.diagnosis);
            this.updateDiagnosis(temp);
        }
    },
    computed: {
        activeDiagnosis() {
            if (this.diagnosis.length > 0) {
                return !this.snapshotView
                    ? this.diagnosis
                          .filter((dia: any) => !dia.ResolvedDate)
                          .map((diag: any, index) => {
                              diag.Order = index + 1;
                              if (diag.Order === 1) {
                                  diag.IsRelated = null;
                                  diag.NotRelatedComments = null;
                              }
                              return diag;
                          })
                    : this.diagnosis;
            }
            return [];
        },
    },
    methods: {
        addDiagnosis() {
            if (this.diagnosis.length == 0) {
                this.isNewTerminal = true;
            } else {
                this.isNewTerminal = false;
            }
            this.newDiagnosis.push({
                Code: "",
                Description: "",
                Order: null,
                IsRelated: null,
                NotRelatedComments: null,
                StartDate: null,
                ResolvedDate: null,
                Billable: null
            });
        },
        saveNewDiagnosis(index: number) {
            let arr = [...this.diagnosis];
            this.newDiagnosis[index].Order = this.activeDiagnosis.length + 1;
            arr.push(this.newDiagnosis[index]);
            this.newDiagnosis.splice(index, 1);
            let temp = [...arr.filter((d: any) => !d.ResolvedDate), ...arr.filter((d: any) => d.ResolvedDate)];
            this.updateDiagnosis(temp);
        },
        cancelSaveNewDiagnosis(index: number) {
            this.newDiagnosis.splice(index, 1);
        },
        makePrimary(index: number) {
            let arr =[... this.diagnosis];
            let newPrimary: any = arr[index];
            newPrimary.IsRelated = null;
            newPrimary.NotRelatedComments = null;
            let oldPrimary = arr[0];
            arr[0] = newPrimary;
            arr[index] = oldPrimary;
            arr = arr.map((diagnosis: any, i) => {
                if (!diagnosis.ResolvedDate) {
                    diagnosis.Order = i + 1;
                }
                return diagnosis;
            });
            let temp = arr;
            this.updateDiagnosis(temp);
        },
        moveDiagnosis(oldIndex: number, newIndex: number) {
            let arr = this.diagnosis;
            if (oldIndex >= arr.length || oldIndex < 0) {
                return;
            }
            if (newIndex >= arr.length || newIndex < 0) {
                return;
            }
            arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
            arr = arr.map((diagnosis: any, index) => {
                if (!diagnosis.ResolvedDate) {
                    diagnosis.Order = index + 1;
                }
                return diagnosis;
            });
            let temp = arr;
            this.updateDiagnosis(temp);
        },
        resolveDiagnosis(index: number) {
            if (this.diagnosis.length > 0 && index < this.diagnosis.length) {
                let orderCount = 1;
                let temp = this.diagnosis.map((diagnosis: any) => {
                    if (!diagnosis.ResolvedDate) {
                        diagnosis.Order = orderCount;
                        orderCount++;
                    }
                    return diagnosis;
                });
                this.updateDiagnosis(temp);
            }
        },
        deleteDiagnosis(index: number) {
            if (this.diagnosis.length > 1 || this.historyView) {
            this.diagnosis.splice(index, 1);
            let temp = this.diagnosis.map((diagnosis: any, diagnosisIndex) => {
                if (!diagnosis.ResolvedDate) {
                    diagnosis.Order = diagnosisIndex + 1;
                }
                return diagnosis;
            });
            this.updateDiagnosis(temp);
        }

        },
        updateDiag(value: any, index: number) {
            let temp = [...this.newDiagnosis];
            temp = temp.map((el, idx) => {
                if (idx === index) {
                    return value;
                } else {
                    return el;
                }
            });
            this.newDiagnosis = temp;
        }
    }
});
